import { useState } from "react";
import { STACK, UsageView, type UsageData, type UsageRange } from "../components/Usage";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 사용이력의 부품 ══
   시안 「공통 · 상태 다섯」(Figma 12-2)을 실물로 세운다 — 읽는 중 · 비었음 · 연결 안 됨 · 모름 · 뒤처짐 · 정상.
   자료는 **견본**이다(서버를 안 부른다). 막대는 진짜 차트 모듈이 그린다 — 따라 그리지 않는다. */

const NOW = Date.UTC(2026, 9, 10, 3, 30);
const SLOTS = Array.from({ length: 48 }, (_, i) => NOW - (47 - i) * 30 * 60 * 1000);

/** 견본 막대 — 낮 시간에 몰리는 모양. 난수 대신 정해진 식이라 볼 때마다 같다. */
function sample(): UsageData {
  const weight = [0.4, 0.8, 1.6, 0.9, 1.4, 0.35, 0.15];
  return {
    range: "1d",
    slotMinutes: 30,
    slots: SLOTS,
    series: STACK.map((s, k) => ({
      status: s.key,
      counts: SLOTS.map((_, i) => {
        const work = i > 4 && i < 26 ? 1 : 0.15;
        return Math.max(0, Math.round(work * weight[k] * (1 + ((i * 7 + k * 3) % 5)) * 0.9 - 0.4));
      }),
    })),
    truncated: false,
    behind: null,
    unknown: null,
  };
}

const NORMAL = sample();
const BEHIND: UsageData = { ...NORMAL, behind: 37 };
const EMPTY: UsageData = { ...NORMAL, series: STACK.map((s) => ({ status: s.key, counts: SLOTS.map(() => 0) })) };
const NOT_CONFIGURED: UsageData = { range: "1d", behind: null, unknown: { kind: "not-configured", detail: null, missing: ["baseUrl", "queryToken"] } };
const UNREACHABLE: UsageData = { range: "1d", behind: null, unknown: { kind: "unreachable", detail: "connection refused", missing: [] } }; // copy-ignore: 견본 자료

function One({ title, data, loading }: { title: string; data: UsageData | null; loading?: boolean }) {
  const [range, setRange] = useState<UsageRange>("1d");
  const [day, setDay] = useState("2026-10-10");
  return (
    <>
      <h3>{title}</h3>
      <UsageView
        data={data}
        loading={loading}
        range={range}
        day={day}
        today="2026-10-10"
        onRange={setRange}
        onDay={setDay}
        onRetry={() => undefined}
      />
    </>
  );
}

export function UsageStates() {
  return (
    <>
      <One title={tx("pat.usage.normal")} data={NORMAL} />
      <One title={tx("pat.usage.behind")} data={BEHIND} />
      <One title={tx("pat.usage.empty")} data={EMPTY} />
      <One title={tx("pat.usage.loading")} data={null} loading />
      <One title={tx("pat.usage.notConfigured")} data={NOT_CONFIGURED} />
      <One title={tx("pat.usage.unknown")} data={UNREACHABLE} />
    </>
  );
}
